export default __webpack_public_path__ + "static/media/s2.9c922527.jpg";